let RoleManager = class {
  static CONTAINER_QUERY_SELECTOR = '#sflowRoleManager';
  static CHAR_DOWN_ARROW = '&#9660;';
  static CHAR_UP_ARROW = '&#9650;';

  data = window.sflow.data;
  el = this.createElementReferences();

  constructor () {
    this.handleSelectChange();
  }

  createElementReferences () {
    const container = document.querySelector(RoleManager.CONTAINER_QUERY_SELECTOR);
    return {
      container: container,
      select: container.querySelector('select'),
      description: container.querySelector('article'),
      navigation: container.querySelector('nav'),
      permissionButtonDirection: container.querySelector('nav .button .direction'),
    };
  }

  getSelectedRole () {
    return this.data.roles.find((role) => role.id === parseInt(this.el.select.value));
  }

  handleSelectChange () {
    let role = this.getSelectedRole();
    sflow.permissionManager.setPermissionsOfRole(role);
    if (role) {
      this.el.description.innerHTML = role.description;
      this.el.description.hidden = false;
      this.el.navigation.hidden = false;
    } else {
      this.el.description.hidden = true;
      this.el.navigation.hidden = true;
    }
  }
};

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector(RoleManager.CONTAINER_QUERY_SELECTOR) !== null) {
    window.sflow.roleManager = new RoleManager();
  }
});
